<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Carian Laporan Rekod Ternakan Bunting Hasil AI">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
               <w-flex class="mt3 filter-row">
                  <div class="filter-col">
                     <z-select style="margin:5px;" :items="negeri" label="Negeri"  v-model="pencarian.lkp_negeri_id"  @input="getBandar()" />
                  </div>
                  <div class="filter-col">
                     <z-select style="margin:5px;" :items="bandar" class="mt4" label="Daerah"  v-model="pencarian.lkp_bandar_id" />
                  </div>
                  <div class="filter-col">
                     <w-select style="margin:5px;"
                       :items="lkp_ternakan" 
                       label="Jenis Ternakan" 
                       v-model="pencarian.lkp_ternakan_id" 
                       @input="getJurusan(pencarian.lkp_ternakan_id)"
                     />
                  </div>
               </w-flex>
               <w-flex class="mt3 filter-row">
                  <div class="filter-col">
                     <w-select style="margin:5px;"
                         :items="lkp_jurusan" 
                         label="Jurusan Ternakan"  
                         v-model="pencarian.lkp_jurusan_id" 
                     />
                  </div>
                  <div class="filter-col">
                     <w-select style="margin:5px;"
                         :items="lkp_tujuan" 
                         label="Tujuan"  
                         v-model="pencarian.lkp_tujuan_id" 
                     />
                  </div>
                  <div class="filter-col">
                      <w-select class="mt4" :items="lkp_status" label="Status Permohonan"  v-model="pencarian.lkp_status_id" multiple />
                    </div>
                  
                </w-flex>
                <w-flex class="mt3 filter-row">
                    <div class="filter-col">
                         <w-input 
                           label="Tarikh PD Dari" 
                           type="date" 
                           v-model="pencarian.tarikh_pd_dari"
                         />
                    </div>
                    <div class="filter-col">
                      <!-- <w-input class="mt4" label="Tarikh Lahir" type="date" v-model="pencarian.tarikh_lahir"/>   -->
                         <w-input 
                           label="Tarikh PD Hingga" 
                           type="date" 
                           v-model="pencarian.tarikh_pd_hingga"
                         />
                    </div>
                      
                    <div class="filter-col">
                    </div>
                </w-flex>
          </w-form>
          <br>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
         <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN SERVICE AI'">
          <template #title>
            SENARAI LAPORAN REKOD TERNAKAN BUNTING HASIL AI
          </template>
            <w-flex justify-end class="mt2">
                <w-button bg-color="success" v-on="on" @click="createExcel()" class="mr2">
                    <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                </w-button>
            </w-flex>
            <br>
          <div class="w-table-wrap" style="max-height: 900px;">
            
            <div class="table-profil-scrol">
              <br><br>
              <table class="w-table" color="light" style="border:1px" width="100%">
                <thead>
                  <tr class="w-table__header text-center" style="border: 1px solid #000;">
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" >
                        BIL
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="14%" >
                        Nama Jurupermanian Beradas
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="15%" >
                        No. Permohonan
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="15%" >
                        Tujuan Pemeriksaan
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="15%" >
                       ID Premis
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="15%" >
                        Maklumat Penternak
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" >
                        Tarikh AI Terkini 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="5%" >
                        Bilangan Pemeriksaan (PD)
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="5%" >
                        Bilangan Kebuntingan (positif)
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="5%" >
                        Bilangan Kebuntingan Hasil AI pertama 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="5%" >
                        Bilangan Kebuntingan (negatif) 
                     </th>
                     <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="5%" >
                        Status Permohonan 
                     </th>
                  </tr>
                </thead>
                <tbody>
                    <template v-if="items.data.length == 0">
                        <tr class="w-table__row" >
                            <td class="w-table__cell text-center" colspan="10"> Tiada Data.</td>
                        </tr>
                    </template>
                  <template  v-for="(dt, ind) in items.data" :key="dt.id">

                    <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                        {{ (items.current_page - 1) * items.per_page + ind + 1 }}</td>

                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jurupermanian ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_permohonan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.tujuan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_premis ?? '-'}} | {{dt.nama_premis ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_penternak ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{$zutil.dateformat(dt.tarikh) ?? '-'}}</td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">{{dt.jumlah_pd ?? '-'}}</td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">{{dt.jumlah_bunting ?? '-'}}</td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">{{dt.jumlah_bunting_ai ?? '-'}}</td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">{{dt.jumlah_tidak_bunting ?? '-'}}</td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">{{dt.lkp_status ?? '-'}}</td>
                        
                    
                     </tr>
                  </template>
                     <tr class="w-table__row">
                        <td class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="7" >
                           JUMLAH 
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;">
                           {{total_jumlah_pd}}
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;">
                           {{total_jumlah_bunting}}
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;">
                           {{total_jumlah_bunting_ai}}
                        </td>
                         <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;">
                           {{total_jumlah_tidak_bunting}}
                        </td>
                     </tr>

                     <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: none;" colspan="10">
                           &nbsp;
                        </td>
                     </tr>
                     <tr class="w-table__row">
                        <td class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="7" >
                          JUMLAH KESELURUHAN TERNAKAN PD (EKOR) 
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="4">
                           {{total_keseluruhan}}
                        </td>
                     </tr>

                     <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: none;" colspan="10">
                           &nbsp;
                        </td>
                     </tr>
                     <tr class="w-table__row">
                        <td class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="7" >
                          JUMLAH KESELURUHAN TERNAKAN BUNTING (EKOR) 
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="4">
                           {{total_jumlah_bunting}}
                        </td>
                     </tr>

                     <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: none;" colspan="10">
                           &nbsp;
                        </td>
                     </tr>
                     <tr class="w-table__row">
                        <td class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="7" >
                          JUMLAH KESELURUHAN TERNAKAN BUNTING HASIL AI 
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="4">
                           {{total_jumlah_bunting_ai}}
                        </td>
                     </tr>
                </tbody>
              </table>
              <br><br>

            </div>
          </div>
           
           
          <table style="border:none;" width="100%">
                <tbody>
                    <tr>
                        <td style="border: none; " width="75%" >
                            <div class="per-page-control">
                                <label for="perPage" class="per-page-label">Rekod per halaman : </label>
                                <select v-model="perPage" @change="changePerPage" id="perPage" class="per-page-select">
                                    <option v-for="opt in perPageOptions" :key="opt" :value="opt">
                                       {{ opt }}
                                    </option>
                                </select>
                            </div>
                        </td>
                        <td style="border: none; " width="25%"  align="right">
                            <nav class="pagination">
                              <button
                              class="pagination-btn"
                              :disabled="!items.prev_page_url"
                              @click="paginate(items.prev_page_url)"
                              >
                                Sebelumnya 
                              </button>

                              <span class="pagination-info">
                                {{ items.current_page }} dari {{ items.last_page }}
                              </span>
                             

                              <button
                              class="pagination-btn"
                              :disabled="!items.next_page_url"
                              @click="paginate(items.next_page_url)"
                              >
                                Seterusnya
                              </button>
                            </nav>
                        </td>
                    </tr>
                </tbody>
            </table>
        </w-card>
        <br>
        <br>
        <br>
        <br>
        <br>

       <!--   <z-table title="Senarai Permohonan Baka" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
         </z-table>
 -->

      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    total_jumlah_pd: Number,
    total_jumlah_bunting: Number,
    total_jumlah_tidak_bunting: Number,
    total_keseluruhan: Number,
    total_jumlah_bunting_ai: Number,
    segmenName: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'laporan.pd'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Laporan KPI', route: '/laporan' },
        { label: 'REKOD TERNAKAN BUNTING HASIL AI', route: 'laporan/pd' },
      ],
      // perPage: this.$page.props.items?.per_page || 1,
      form : this.datas,
     

      pencarian: {
         lkp_negeri_id: '',
         lkp_bandar_id: '',
         lkp_jenis_baka_id: '',
         lkp_ternakan_id: '',
         lkp_jurusan_id: '',
         lkp_tujuan_id: '',
         tarikh_pd_dari: '',
         tarikh_pd_hingga: '',
         lkp_status_id: [],
      },
      premis: [],
      negeri:[],
      bandar:[],
      lkp_jurusan :[],
      lkp_ternakan : [],
      lkp_tujuan: [],
      lkp_status : [],

      perPageOptions: [5, 10, 50, 99],
      perPage: this.items.per_page || 10,
      
    }
  },
  methods: {
    paginate(url) {
        let params = {
            ...this.pencarian,
        };

        this.$inertia.get(url, params, {
            preserveState: true,
            preserveScroll: true,
            replace: true,
        });

    },

    changePerPage() {
        let params = {
            ...this.pencarian,
            per_page: this.perPage,
            page: 1
        };
        this.$inertia.visit(route(route().current(), params), {
            preserveState: true,
            preserveScroll: true,
        });
    },
   
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

   
   getJenisBaka(){
      this.$zcomm.get(this.api_service + 'lookup/jenis_baka', {}).then(res => {
        this.lkp_jenis_baka = res
      })
    },

   getNegeri(){
        this.$zcomm.get(this.api_service + 'lookup/negeri/'+1, {}).then(res => {
          this.negeri = res

        })
      },
   getBandar(){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.pencarian.lkp_negeri_id, {}).then(res => {
          this.bandar = res
        })
      },
    getTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

    getJurusan(i){
         this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
           this.lkp_jurusan = res
         })
       },
   getTujuanPd(){
      this.$zcomm.get(this.api_service + 'lookup/tujuan', {}).then(res => {
        this.lkp_tujuan = res
      })
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_art_kpi', {}).then(res => {

        // tambah option pilih semua
        this.lkp_status = [
          { label: ' -- SEMUA --', value: 'all' },
          ...res
        ]

      })
    },


   createExcel() {
      const params = {
         lkp_negeri_id: this.pencarian.lkp_negeri_id || '',
         lkp_bandar_id: this.pencarian.lkp_bandar_id || '',
         lkp_jenis_baka_id: this.pencarian.lkp_jenis_baka_id || '',
         lkp_ternakan_id: this.pencarian.lkp_ternakan_id || '',
         lkp_jurusan_id: this.pencarian.lkp_jurusan_id || '',
         lkp_tujuan_id: this.pencarian.lkp_tujuan_id || '',
         tarikh_pd_dari: this.pencarian.tarikh_pd_dari || '',
         tarikh_pd_hingga: this.pencarian.tarikh_pd_hingga || '',
         lkp_status_id: this.pencarian.lkp_status_id?.join(',') || '', // multiselect
         excel: 1 // penanda untuk generate Excel
      };
      const queryString = new URLSearchParams(params).toString();
      const url = route('kpi.pd') + '?' + queryString;
      window.open(url, '_blank');

    // const url = route('laporan.service.service_ai') + '?' + new URLSearchParams(params).toString();
    // window.open(url, '_blank');
   }


  },

  watch: {

  },

  mounted() {
   this.getJenisBaka();
   this.getNegeri(); 
   this.getTernakan();
   // this.getJurusan();
    this.getTujuanPd();
   this.getStatus();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.pagination-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  font-weight: bold;
}
.w-table thead tr:nth-child(1) th {
  position: sticky;
  top: 2px;
  background: #fff;
  z-index: 3;
}

/* Header baris kedua */
.w-table thead tr:nth-child(2) th {
  position: sticky;
  top: 32px; /* sesuaikan dengan tinggi row pertama */
  background: #fff;
  z-index: 2;
}


.role-selector {
  width: 100%;
  max-width: 400px;
  border: 2px solid #1976d2;
  border-radius: 8px;
  background-color: #f5f5f5;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-weight: bold;
}

.role-selector .w-select__selection {
  padding: 12px 16px;
  font-size: 16px;
}

.role-selector .w-select__label {
  font-weight: bold;
  color: #1976d2;
}
.filter-row {
  display: flex;
  gap: 10px;
}

.filter-col {
  flex: 1;
  min-width: 220px; /* optional – elak jadi terlalu kecil */
}
</style>
